/**
 * Cookies Message
 */
export function cookiesMessage() {
  const cookiesMessage = document.querySelector('.cookies-message');
  const cookiesMessageClose = document.querySelector(
      '.cookies-message__button');

  cookiesMessageClose.addEventListener('click', function() {
    localStorage.setItem('cookies-agreement-viewed', 'true');
    cookiesMessage.classList.remove('cookies-message--show');
  });

  if (localStorage.getItem('cookies-agreement-viewed') !== 'true') {
    cookiesMessage.classList.add('cookies-message--show');
  }
}
